const paths = {
  phone: 'M7 3h3l1.4 4-2 1.4a15 15 0 0 0 6.2 6.2l1.4-2 4 1.4v3a4 4 0 0 1-4 4C9.3 21 3 14.7 3 7a4 4 0 0 1 4-4Z',
  plate: 'M4 7h16v10H4zM7 11h3m4 0h3m-10 3h2m5 0h3',
  search: 'M21 21l-4.35-4.35m2.1-5.4a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0Z',
  user: 'M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2m7-10a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z',
  plus: 'M12 5v14M5 12h14',
  car: 'M5 17h14M6 17l-1-4 2-5h10l2 5-1 4M8 17v2m8-2v2M7 13h.01M17 13h.01',
  check: 'm5 12 4 4L19 6',
  chevron: 'm9 18 6-6-6-6',
  close: 'M6 6l12 12M18 6 6 18',
  calendar: 'M5 4h14a2 2 0 0 1 2 2v14H3V6a2 2 0 0 1 2-2Zm0 5h14M8 2v4m8-4v4',
};

export default function ServiceOneIcon({ name }) {
  return <svg viewBox="0 0 24 24" aria-hidden="true"><path d={paths[name]} /></svg>;
}
